<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <ServerTextEditor v-model="value.parameter1" title="Sender Address" />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="value.parameter2"
          label="Send to Current User"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <ServerTextEditor v-model="value.parameter3" title="Recipient Address" />
      </v-col>
      <v-col cols="12">
        <ServerTextEditor v-model="value.parameter4" title="Subject" />
      </v-col>
      <v-col cols="12">
        <ServerTextEditor v-model="value.parameter5" title="Body" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServerTextEditor from "../../ui/shared/ServerTextEditor.vue";

export default {
  name: "SendMailDesigner",

  components: { ServerTextEditor },

  props: ["value"],
};
</script>